<button class="btn btn-link" style="padding-left: 0px;" (click)="showContent()">{{ linkText || 'View' }} <ep-svg-icon icon="eye"></ep-svg-icon></button>